import { GrantsTable } from 'components/table/grants/Table';

const Grants = () => {
    return (
        <GrantsTable />
    );
}


export { Grants };